import axios from 'axios';
import * as utils from '@/apis/apiUtils';
import type {
  EmergencyResponseTeamCar,
  EmergencyResponseTeamCarShow,
} from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamCar';
import type {
  EmergencyResponseTeamCarCreateOrUpdateParams,
  EmergencyResponseTeamCarUpdateReportIdParams,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamCarRequest';
import {
  EmergencyResponseTeamCarCreateOrUpdateResponse,
  EmergencyResponseTeamCarShowResponse,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamCarResponse';
import {
  convertEmergencyResponseTeamReportsResponseToEmergencyResponseTeamReports,
} from '@/apis/externalReports/emergencyResponseTeam/emergency_response_team_report';

export default {
  async createOrUpdate(
    params: EmergencyResponseTeamCarCreateOrUpdateParams,
  ): Promise<EmergencyResponseTeamCar> {
    const { data } = await axios.post<EmergencyResponseTeamCarCreateOrUpdateResponse>(
      utils.getApiUrl('/external_reports/emergency_response_team/cars'),
      params,
    );
    return convertEmergencyResponseTeamCarResponseToEmergencyResponseTeamCar(data);
  },
  async updateReportId(
    id: number,
    params: EmergencyResponseTeamCarUpdateReportIdParams,
  ): Promise<EmergencyResponseTeamCar> {
    const { data } = await axios.post<EmergencyResponseTeamCarCreateOrUpdateResponse>(
      utils.getApiUrl(`/external_reports/emergency_response_team/cars/${id}`),
      params,
    );
    return convertEmergencyResponseTeamCarResponseToEmergencyResponseTeamCar(data);
  },
  async getEmergencyResponseTeamCars(): Promise< EmergencyResponseTeamCarShow[] > {
    const { data } = await axios.get<EmergencyResponseTeamCarShowResponse[]>(
      utils.getApiUrl('/external_reports/emergency_response_team/cars'),
    );
    return convertEmergencyResponseTeamCarsResponseToEmergencyResponseTeamCars(data);
  },
};
function convertEmergencyResponseTeamCarResponseToEmergencyResponseTeamCar(
  car: EmergencyResponseTeamCarCreateOrUpdateResponse,
): EmergencyResponseTeamCar {
  return {
    id: car.id,
    lat: car.lat,
    lon: car.lon,
    status: car.status,
    ts: car.ts,
    currentReportId: car.current_report_id,
    userId: car.user_id,
    statusDisp: car.status_disp,
    companyId: car.company_id,
    companyName: car.company_name,
  };
}

function convertEmergencyResponseTeamCarsResponseToEmergencyResponseTeamCars(
  cars: EmergencyResponseTeamCarShowResponse[],
): EmergencyResponseTeamCarShow[] {
  return cars.map((car) => ({
    id: car.id,
    lat: car.lat,
    lon: car.lon,
    status: car.status,
    ts: car.ts,
    carName: car.car_name,
    currentReportId: car.current_report_id,
    userId: car.user_id,
    statusDisp: car.status_disp,
    report: car.report
      ? convertEmergencyResponseTeamReportsResponseToEmergencyResponseTeamReports([car.report])[0]
      : null,
    hanName: car.han_name,
    tsIsNew: Boolean(car.ts_is_new),
    companyId: car.company_id,
    companyName: car.company_name,
  }));
}
